import { cn } from '@/renderer/lib/utils';
import { BillingCycle } from '@/renderer/types/billing';
import React from 'react';

interface BillingCycleToggleProps {
  value: BillingCycle;
  onChange: (value: BillingCycle) => void;
}

const cycleOptions: Array<{ label: string; value: BillingCycle }> = [
  { label: 'Yearly', value: 'annual' },
  { label: 'Semi-Annually', value: 'semi_anually' },
  { label: 'Monthly', value: 'monthly' },
];

export const BillingCycleToggle: React.FC<BillingCycleToggleProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="inline-flex rounded-full border border-emerald-100 bg-emerald-50/80 p-1">
      {cycleOptions.map((option) => {
        const isActive = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'rounded-full px-4 py-2 text-sm font-medium transition',
              isActive
                ? 'bg-white text-slate-950 shadow-sm'
                : 'text-slate-500 hover:text-slate-900',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
